module.exports = __webpack_public_path__ + "static/media/Rounds-05.ea60a3c9.png";